import { render } from "./mapComponentArchive.vue?vue&type=template&id=2c6e86b6"
import script from "./mapComponentArchive.vue?vue&type=script&lang=js"
export * from "./mapComponentArchive.vue?vue&type=script&lang=js"

import "./mapComponentArchive.vue?vue&type=style&index=0&id=2c6e86b6&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__